// export const baseURL =
// "https://testobl-engpezf9efa0aje3.eastus2-01.azurewebsites.net/api/v1";
export const baseURL = "https://obl-api.nmfb.com.ng/api/v1";

export const imgURL = baseURL.replace("/api/v1", "");
